import React, { HTMLAttributes } from "react";
import PhoneNumberInput, {
  isPossiblePhoneNumber as _isPossiblePhoneNumber
} from "react-phone-number-input/min";

import { InputText } from "../InputText/InputText";
import CountrySelect from "./CountrySelect";
import styles from "./PhoneInput.module.scss";
import clsx from "clsx";
import { ValidationInputState } from "../../ValidationInputState";
import type { Country } from "react-phone-number-input/min";
import type { Props } from "react-phone-number-input";

type BaseProps = Props<HTMLAttributes<HTMLInputElement>>;
export type PhoneInputProps = BaseProps & {
  country?: Country;
  className?: string;
  validationState?: ValidationInputState;
  disabled?: boolean;
};

const Input = React.forwardRef<HTMLInputElement>(function Input(
  props: Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">,
  ref
) {
  return <InputText {...props} ref={ref} variant="default" />;
});

const PhoneInputBase = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  function __PhoneInputBase(
    {
      country,
      className,
      validationState = undefined,
      disabled = false,
      ...props
    },
    ref
  ) {
    return (
      <PhoneNumberInput
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref={ref as any}
        placeholder="Enter phone number"
        flags={undefined}
        defaultCountry={country}
        international={false}
        inputComponent={Input}
        countrySelectComponent={CountrySelect}
        countrySelectProps={{ validationState, disabled }}
        numberInputProps={{ validationState }}
        className={clsx([styles.input, className])}
        data-testid="phone-input"
        disabled={disabled}
        {...props}
      />
    );
  }
);

export const PhoneInput = PhoneInputBase;
export const isPossiblePhoneNumber = _isPossiblePhoneNumber;
